import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/BankDeposit Request/SideMenu';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import SnackBar from './Components/General/SnackBar';
import BackdropLoader from './Components/General/Loader';
import { GetBankDepositRequest } from 'API/DS_Wallet/api';


const BankDepositRequest = () => {


    const [activeStep,setActiveStep]=useState(0)
    const [RequestData, setRequestData] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(null)
    const [AlertType, setAlertType] = useState("success")
    const [AlertMessage, setAlertMessage] = useState("")
    const [Page,setPage]=useState(1)




    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setOpenAlert(true)
    }



    useEffect(() => {
        if(activeStep===0){
            GetBankDepositRequest(1,10,setIsLoading, setRequestData, handleAlertOpen,"pending")
            setPage(1)
        }
        else if(activeStep===1){
            GetBankDepositRequest(1,10,setIsLoading, setRequestData, handleAlertOpen,"approved")
            setPage(1)

        }
        else{
            GetBankDepositRequest(1,10,setIsLoading, setRequestData, handleAlertOpen,"rejected")
            setPage(1)

        }
    }, [activeStep])

    const handlePageChange = (event, newPage) => {
        console.log("page", newPage);
        
        setPage(newPage)
        GetBankDepositRequest(newPage , 10, setIsLoading, setRequestData, handleAlertOpen, activeStep === 0 ? "pending" : activeStep === 1 ? "approved" : "rejected")
    }


    // console.log("data", RequestData);


    return (
        <Box>
            <BackdropLoader open={isLoading} />
            <SnackBar open={openAlert} handleClose={handleAlertClose} type={AlertType} message={AlertMessage} />
            <MainCard sx={{ height: '100%', overflowX: 'scroll' }}>
                <SideMenu setActiveStep={setActiveStep} data={RequestData} handlePageChange={handlePageChange} Page={Page}/>
            </MainCard>
        </Box>
    )
}

export default BankDepositRequest